import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import useAuthToken from "../../../hooks/useAuthToken";

const StartScreen = () => {

    const navigate = useNavigate();
    const token = useAuthToken();

    useEffect(() => {
        if (token) {
            navigate('/devices');
        } else {
            navigate('/login');
        }
    }, []);

    return (
        <div>
        </div>
    );
}

export default StartScreen;